<script setup lang="ts">
import { MAlert } from '@mumble/components'
import { Alert } from '@mumble/hooks/types/alert.types'

interface Props {
    alert: Alert
}

defineProps<Props>()
</script>

<template>
    <MAlert v-if="alert.data.isVisible" class="mb-5" :type="alert.data.type">
        {{ alert.data.content }}
    </MAlert>
</template>
